<template>
    <div>
        <div class="loading-spinner-outer" v-if="saving">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
                <div class="loading-spinner-content">
                    Saving, please wait
                </div>
            </div>
        </div>
        <div class="box">
            <div class="box-content">
                <div class="flex-sm">
                    <div class="pr-3">
                      <div class="form-group">
                        <label>Title</label>
                        <input type="text" v-model="course.title" class="form-control">
                      </div>
                    </div>
                    <div class="pr-3">
                      <div class="form-group">
                        <label>Type</label>
                        <select class="form-control" v-model="course.commercial_training_course_type_id">
                          <option :value="1">Webinar</option>
                          <option :value="2">Video</option>
                          <option :value="3">On Site</option>
                        </select>
                      </div>
                    </div>
                    <div class="pr-3" v-if="course.commercial_training_course_type_id === 2">
                      <div class="form-group">
                        <label>Video ID</label>
                        <input type="text" v-model="course.video_embed_id" class="form-control">
                      </div>
                    </div>
                    <div class="pr-3" v-if="course.commercial_training_course_type_id !== 2">
                      <div class="form-group">
                        <label>Open for Bookings</label>
                        <select class="form-control" v-model="course.bookings_open">
                          <option :value="true">Yes</option>
                          <option :value="false">No</option>
                        </select>
                      </div>
                    </div>
                  <div class="flex" v-if="course.commercial_training_course_type_id !== 2">
                    <div class="flex">
                        <div class="form-group mr-3">
                            <label>Start Time</label>
                            <datepicker input-class="form-control" v-model="course.start" :show-second="false" :minute-step="15" :disabled-date="dateNotBeforeToday" type="datetime" value-type="timestamp"></datepicker>
                        </div>
                        <div class="form-group">
                            <label>End Time</label>
                            <datepicker input-class="form-control" v-model="course.end" :show-second="false" :minute-step="15" :disabled-date="dateNotBeforeStart" type="datetime" value-type="timestamp"></datepicker>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                    <label>Summary</label>
                    <wysiwyg v-model="course.summary"></wysiwyg>
                </div>
                <div class="form-group">
                    <label>Description</label>
                    <wysiwyg v-model="course.description"></wysiwyg>
                </div>
                <div class="flex">
                    <div class="half-width-sm pr-3-sm">
                        <div class="form-group mb-0 full-height flex flex-col">
                            <label>Upload Image</label>
                            <form :action="`${$aws_upload_url}`" method="post"
                                  enctype="multipart/form-data" id="amazon_form">
                                <input type="hidden" name="policy" :value="aws_policy">
                                <input type="hidden" name="x-amz-algorithm" value="AWS4-HMAC-SHA256">
                                <input type="hidden" name="x-amz-credential" :value="aws_credential">
                                <input type="hidden" name="x-amz-date" :value="aws_date">
                                <input type="hidden" name="x-amz-signature" :value="aws_signature">
                                <input type="hidden" name="acl" value="private">
                                <input type="hidden" name="success_action_redirect" value="/news/manage">
                                <input type="hidden" name="Content-Type" v-model="filetype">
                                <input type="hidden" name="key" v-model="course.filename">
                            </form>
                            <vue-dropzone
                                ref="fileUploadDropzone"
                                id="dropzone"
                                :options="dropzoneOptions"
                                v-on:vdropzone-removed-file="fileRemovedFromDropZone"
                                v-on:vdropzone-file-added="fileAddedToDropZone"
                                :useCustomSlot="true"
                            >
                                <div>
                                    <div class="mb-3">
                                        DRAG AND DROP FILE
                                    </div>
                                    <div class="mb-3">
                                        OR
                                    </div>
                                    <div>
                                        <a class="btn-secondary-outline">
                                            Choose a file
                                        </a>
                                    </div>
                                </div>
                            </vue-dropzone>
                        </div>
                    </div>
                </div>
                <div class="align-right mt-3">
                    <a class="btn-primary" @click.prevent="save()">
                        Save
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import vue2Dropzone from 'vue2-dropzone';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    props: [
       'aws_policy',
       'aws_credential',
       'aws_date',
       'aws_signature',
    ],
    components: {
        'vue-dropzone': vue2Dropzone,
        'datepicker': DatePicker,
    },
    data() {
        return {
            course: {
              commercial_training_course_type_id: 1,
              bookings_open: true,
              video_embed_id: null,
            },
            loading: true,
            filename: '',
            filetype: '',
            saving: false,
            uploaded_file: null,
            dropzoneOptions: {
                url: '/',
                autoProcessQueue: false,
                uploadMultiple: true,
                addRemoveLinks: true,
            },
        };
    },
    methods: {
        fileAddedToDropZone(uploadedFile) {
            const extension = uploadedFile.name.replace(/^.*\./, '');

            const allowed_extensions = [
                'jpg', 'jpeg', 'png',  'svg', 'gif', 'bmp',
            ];

            if(!allowed_extensions.includes(extension.toLowerCase())) {
                this.$refs.fileUploadDropzone.dropzone.removeAllFiles();
                Swal.fire({
                    title: 'Invalid File Type',
                    icon: 'error',
                    text: 'File type not allowed, please ensure the file is one of the following formats: \'jpg\', \'jpeg\', \'png\',  \'svg\', \'gif\', \'bmp\','
                });
                return;
            }

            if (this.$refs.fileUploadDropzone.dropzone.files.length > 1) {
                this.$refs.fileUploadDropzone.dropzone.removeFile(this.$refs.fileUploadDropzone.dropzone.files[0]);
            }

            const filename = 'commercial_training_course_images/' + Date.now();
            this.course.filename = filename + '.' + extension;

            this.filetype = uploadedFile.type;
            this.uploaded_file = uploadedFile;
        },
        fileRemovedFromDropZone(file) {
          this.uploaded_file = null;
        },
        save() {
          this.saving = true;

          if(this.course.commercial_training_course_type_id === 2) {
              this.course.bookings_open = false;
            }
            const validationErrors = Validate({
                title: this.course.title,
                summary: this.course.summary,
                description: this.course.description,
                image: this.uploaded_file,
            }, {
                title: {
                    presence: {
                        allowEmpty: false,
                    },
                },
                summary: {
                    presence: {
                        allowEmpty: false,
                    },
                },
                description: {
                    presence: {
                        allowEmpty: false,
                    },
                },
                image: {
                    presence: {
                        allowEmpty: false,
                        message: 'must be uploaded'
                    },
                },
            });

            if (validationErrors) {
                Swal.fire({
                    title: 'Unable to save course',
                    icon: 'error',
                    html: `<div class="mb-3">${Object.values(validationErrors).join('</div><div class="mb-3">')}</div>`,
                });
              this.saving = false;
              return;
            }

            if(this.course.commercial_training_course_type_id === 2 && this.course.video_embed_id === null) {
                Swal.fire({
                  title: 'Video ID Missing',
                  icon: 'error',
                  html: `<div class="mb-3">Please enter a youtube video ID</div>`,
                });
              this.saving = false;
              return;
            }

            axios.post('/commercial/training/create',{
                course: this.course,
            }).then((response) => {
                let form_data = new FormData(document.querySelector('#amazon_form'));
                form_data.append('file', this.uploaded_file);
                axios({
                    method: 'post',
                    url: this.$aws_upload_url,
                    data: form_data,
                    headers: {'Content-Type': 'multipart/form-data' }
                }).then(() => {
                    window.location.href = '/commercial/training';
                });
            });
        },
        dateNotBeforeToday(date) {
            const today = new Date();
            const end = new Date(this.course.end);
            today.setHours(0, 0, 0, 0);
            end.setHours(0, 0, 0, 0);
            date.setHours(0, 0, 0, 0);
            return date < today || date > end;
        },
        dateNotBeforeStart(date) {
          const start = new Date(this.course.start);
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          start.setHours(0, 0, 0, 0);
          date.setHours(0, 0, 0, 0);
          return date < today || date < start;
        },
    },
};
</script>
